import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { APP_ROUTES } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { loaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { offlineInterceptor } from '@shared/interceptors/offline.interceptor';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { environment } from '@environments/environment';
import { OfflineDownloadService } from '@shared/services/offline/offline-download.service';
import { OfflineSyncService } from '@shared/services/offline/offline-sync.service';

function initOfflinePlatform(
  downloadService: OfflineDownloadService,
  syncService: OfflineSyncService,
): () => void {
  return () => {
    if (!environment.OFFLINE_MODE_ENABLED) {
      return;
    }
    downloadService.initRouteWarming();
    void syncService.drainPendingMutations();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([
      authInterceptor,
      offlineInterceptor,
      loaderInterceptor,
      errorInterceptor,
    ])),
    importProvidersFrom([NgxDaterangepickerMd.forRoot()]),
    { provide: LOCALE_ID, useValue: 'en-US' },
    {
      provide: APP_INITIALIZER,
      useFactory: initOfflinePlatform,
      deps: [OfflineDownloadService, OfflineSyncService],
      multi: true,
    },
    provideServiceWorker('ngsw-worker.js', {
      // Offline refresh requires a registered SW to serve the app shell when the network is down.
      // Gating on production only breaks offline QA on ng serve / proxy.
      enabled: environment.OFFLINE_MODE_ENABLED,
      // Register immediately so the shell is cached before the user goes offline or closes the tab.
      registrationStrategy: environment.OFFLINE_MODE_ENABLED
        ? 'registerImmediately'
        : (isDevMode() ? 'registerImmediately' : 'registerWhenStable:5000'),
    }),
  ],
};
